import { requestApiUser } from "../functions"
import tokens from "../../utils/token"

export default {
    login: async (email, password) => {
        const res = await requestApiUser('/users/login', 'POST', {
            email,
            password
        });

        if(res.data.token) {
            tokens.user_token.setToken(res.data.token);
            window.location.href = '/admin/dashboard';
        }
        return res;
    },

    register: async (email, password) => {
        const res = await requestApiUser('/users/register', 'POST', {
            email,
            password
        });

        if(res.data.token) {
            await tokens.user_token.setToken(res.data.token);
            window.location.href = '/admin/dashboard';
        }
        return res;
    },
}